// KL guide: working out during puasa. Distinct from the Dubai Ramadan guide:
// Malaysian context (berbuka, sahur, bazaar Ramadan, terawih, KL heat & rain).
const content = {
    slug: 'puasa-workout-tips',
    title: 'Working Out During Puasa | Tips for KL',
    description: 'How to keep training during puasa in Malaysia: the best time around berbuka, terawih and sahur, what to eat from the bazaar Ramadan, and how hard to go.',
    eyebrow: 'KL · Fitness guide',
    h1: 'Working Out During Puasa: Practical Tips for KL',
    lead: 'Between long workdays, KL traffic, buka puasa with family and terawih at night, Ramadan leaves little room for the gym. The good news: two or three short, well-timed sessions a week are enough to hold on to your fitness.',
    datePublished: '2026-10-03',
    image: 'fitness1.jpg',
    imageAlt: 'Light strength training session',
    summary: {
        title: 'Five quick tips',
        items: [
            'Train after berbuka, or lightly in the hour before.',
            'Keep sessions to 30-45 minutes.',
            'Prioritise strength over long cardio.',
            'Drink steadily from berbuka to sahur.',
            'Go easy on the bazaar kuih and fried food before training.',
        ],
    },
    sections: [
        {
            title: 'When to train',
            cards: [
                { title: 'Just before berbuka', body: 'A walk or light mobility session in the last hour of fasting - you can drink right after. Avoid hard effort in the afternoon heat.' },
                { title: 'After berbuka, before terawih', body: 'Tight on time, but workable for a short strength session if you eat lightly first.' },
                { title: 'After terawih', body: 'The most popular slot for harder sessions - many condo gyms are quiet late at night.' },
            ],
        },
        {
            title: 'Eating around your training',
            items: [
                'Break fast with water and dates, then a proper meal with rice or noodles plus protein - ayam, ikan, telur or tempe.',
                'Bazaar Ramadan favourites are fine in moderation; just keep the fried and very sweet items for after training, not before.',
                'At sahur, oats, wholemeal bread, eggs and fruit release energy slowly through the day.',
                'Limit sweet drinks like air sirap and teh tarik at sahur - they make you thirstier.',
            ],
        },
        {
            title: 'How hard to go',
            paragraphs: [
                'Aim to maintain, not to break records. Keep the weights you normally lift but do fewer sets, or reduce the weight slightly and keep the reps. Skip high-intensity intervals unless you train well after berbuka and feel good. If you feel dizzy, stop.',
                'People with diabetes, heart conditions, or who are pregnant should talk to their doctor about exercise and fasting before Ramadan starts.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is it okay to exercise while fasting?',
            answer: 'Light exercise is generally fine for healthy adults. Do harder sessions after berbuka when you can drink and eat.',
        },
        {
            question: 'Will I lose weight during puasa?',
            answer: 'Some people do, many don\'t - large berbuka meals and sweet drinks add up. Keeping two or three strength sessions a week helps you keep muscle either way.',
        },
    ],
    cta: {
        title: 'Train after terawih with a coach',
        body: 'Trainers can schedule late-evening sessions in your condo gym during Ramadan.',
        href: '/my/personal-trainer-kuala-lumpur',
        label: 'Personal trainers in KL',
    },
}

export default content
